import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { AddressEntity } from '~/types/address'

export const useAddressesStore = defineStore('addresses', () => {
  const addresses = ref<AddressEntity[]>([])

  function getAll(): AddressEntity[] {
    return addresses.value
  }

  function getById(id: string): AddressEntity | null {
    return addresses.value.find(a => a.id === id) ?? null
  }

  function setAddresses(items: AddressEntity[]): void {
    addresses.value = items
  }

  function upsert(address: AddressEntity): void {
    const index = addresses.value.findIndex(a => a.id === address.id)
    if (index === -1) {
      addresses.value.unshift(address)
    }
    else {
      addresses.value[index] = address
    }
  }

  return { addresses, getAll, getById, setAddresses, upsert }
})

export type AddressesStore = ReturnType<typeof useAddressesStore>

